/**
 * Cache Types
 *
 * Types for message and conversation caching
 */

import { EnhancedMessage, Conversation } from "@/types/centralizedChat";

export interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

export interface MessageCacheEntry extends CacheEntry<EnhancedMessage[]> {
  pagination: {
    currentPage: number;
    hasMore: boolean;
    totalPages: number;
    totalCount: number;
  };
}

export interface ConversationCacheEntry extends CacheEntry<Conversation[]> {
  filters: string;
}

export const CACHE_TTL_MS = 30000; // 30 seconds
export const STALE_WHILE_REVALIDATE_MS = 60000; // 60 seconds
